export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#fbfaf7",
    hexDark: "#16130f",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#f3f0ea",
    hexDark: "#211d17",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "#e6e1d6",
    hexDark: "#322c22",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#4a443b",
    hexDark: "#d8d0c2",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#201b15",
    hexDark: "#f6f2ea",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#857c6e",
    hexDark: "#9d9384",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "#0f7d73",
    hexDark: "#38b9ac",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "#e6f2f0",
    hexDark: "#123330",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "#0b675f",
    hexDark: "#6fd3c8",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#e0a021",
    hexDark: "#f0b64a",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#fbf1de",
    hexDark: "#2f2716",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "#b07c0d",
    hexDark: "#f7cd7e",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "#cf4c3f",
    hexDark: "#ec6a5c",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "#f7e6e1",
    hexDark: "#3a1e1a",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "#b23a2e",
    hexDark: "#f2897b",
  },
];

export const FONTS = {
  display: "Fraunces",
  body: "DM Sans",
};
